import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface ManufacturingFeature {
  title: string;
  image: string;
  points: string[];
}

@Component({
  selector: 'app-manufacturing-features',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './manufacturing-features.html',
  styleUrls: ['./manufacturing-features.css'],
})
export class ManufacturingFeaturesComponent {
  readonly features: ManufacturingFeature[] = [
    {
      title: 'Work Centers',
      image: 'images/modules/work-center.PNG',
      points: ['Capacity & machine cost per hour', 'Multiple shifts', 'Feeds routing & costing'],
    },
    {
      title: 'Labor Rates',
      image: 'images/modules/labor.PNG',
      points: ['Hourly labor rates', 'Scope by work center or all', 'Effective date ranges'],
    },
    {
      title: 'Standard Costs',
      image: 'images/modules/costs.PNG',
      points: ['Material, labor, machine & overhead', 'Total cost per product', 'Ready for variance analysis'],
    },
    {
      title: 'Overhead Rules',
      image: 'images/modules/rules.PNG',
      points: ['Percentage, per-hour & fixed rules', 'Applied automatically in costing', 'Effective date tracking'],
    },
    {
      title: 'Material Planning',
      image: 'images/modules/material.PNG',
      points: ['MRP planning & demand analysis', 'Auto-generate planned orders', 'Reorder point & safety stock'],
    },
    {
      title: 'Capacity Load',
      image: 'images/modules/load.PNG',
      points: ['Work center utilization %', 'Overload detection', 'Shift-level scheduling'],
    },
    {
      title: 'Quality Inspections',
      image: 'images/modules/inspections.PNG',
      points: ['Inspected, passed & rejected tracking', 'Pass rate by order', 'Feeds rework decisions'],
    },
    {
      title: 'Subcontract Orders',
      image: 'images/modules/orders.PNG',
      points: ['Outsourced processing steps', 'Vendor, quantity & unit cost', 'Expected return tracking'],
    },
    {
      title: 'Inventory Transactions',
      image: 'images/modules/transactions.PNG',
      points: ['Scrap receipts & goods issues', 'Linked to production orders', 'Full transaction history'],
    },
  ];
}
